<template>
    <div>
        <div id="main_select_list">
            <div class="main" v-for="item in mainList" :key="item.name">
                <a :href="item.path">
                    <div class="main_icon">
                        <img :src="item.path.lastIndexOf(path)!=-1?item.showImg:item.img"/>
                    </div>
                    <!-- <div class="main_describe">{{item.name}}</div> -->
                </a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'main_list',
    data(){
        return {
            mainList:[
                {
                    name:'游戏',
                    path:'#/game/home',
                    img:'https://wd-2019-1256239864.cos.ap-guangzhou.myqcloud.com/front/游戏/首页入口icon/游戏-未选中@3x.png',
                    showImg:'https://wd-2019-1256239864.cos.ap-guangzhou.myqcloud.com/front/游戏/首页入口icon/游戏-选中@3x.png',
                },
                // {
                //     name:'SHOW',
                //     path:'#/game/show',
                //     img:'https://wd-2019-1256239864.cos.ap-guangzhou.myqcloud.com/front/游戏/首页入口icon/show-未选中@3x.png',
                //     showImg:'https://wd-2019-1256239864.cos.ap-guangzhou.myqcloud.com/front/游戏/首页入口icon/show-选中@3x.png',
                // },
                // {
                //     name:'关注',
                //     path:'#/game/attention',
                //     img:'https://wd-2019-1256239864.cos.ap-guangzhou.myqcloud.com/front/游戏/首页入口icon/关注-未选中@3x.png',
                //     showImg:'https://wd-2019-1256239864.cos.ap-guangzhou.myqcloud.com/front/游戏/首页入口icon/关注-选中@3x.png',
                // },
                {
                    name:'动态',
                    path:'#/game/community',
                    img:'https://wd-2019-1256239864.cos.ap-guangzhou.myqcloud.com/front/游戏/首页入口icon/动态-未选中@3x.png',
                    showImg:'https://wd-2019-1256239864.cos.ap-guangzhou.myqcloud.com/front/游戏/首页入口icon/动态-选中@3x.png',
                },
                {
                    name:'我的',
                    path:'#/game/my',
                    img:'https://wd-2019-1256239864.cos.ap-guangzhou.myqcloud.com/front/游戏/首页入口icon/我的-未选中@3x.png',
                    showImg:'https://wd-2019-1256239864.cos.ap-guangzhou.myqcloud.com/front/游戏/首页入口icon/我的-选中@3x.png',
                }
            ]
        }
    },
    props:['path'],
}
</script>
<style lang="less" scoped>
    #main_select_list{
        display: flex;
        height: 4em;
        border-top: 0.03em solid #CCC;
        .main{
            flex:1;
            height: 4em;
            text-align: center;
            .main_icon{
                margin-top: 0.2em;
                img{
                    // height: 2.5em;
                    height: 3.5rem;
                }
            }
            .main_describe{
                height:1em;
                font-size:0.71em;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(142,142,147,1);
                line-height:1em;
            }
        }
    }
</style>